var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column loading-page"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}}),_c('span',{staticClass:"loading-text"},[_vm._v("Carregando...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }